import React, { useEffect, useState } from 'react';
import SettingContainer from '../SettingContainer';
import SettingListItem from '../SettingListItem';
import { useConfig } from '../../../DataStore/ConfigContext';
import ActivityLoader from '../../Common/ActivityLoader';
import Notification from '../../Common/Notification';
import { useTheme } from '../../../DataStore/ThemeContext';

const Houses = () => {

    const {openSettings} = useTheme();

    const [activeRecord, setActiveRecord] = useState(null);
    const {houses, getHouses} = useConfig();


    useEffect(()=>{
        getHouses();
    }, [])

    const handleNew = ()=>{
        openSettings("New House", "NewHouse");
    }

    const handleEdit = ()=>{
        openSettings("Edit House", "EditHouse", activeRecord);
    }

   
    const menu = ()=>{

        return(<>
            <button type="button" tabIndex="0" className="dropdown-item" onClick={handleNew}>
                <i className="dropdown-icon fa fa-plus"> </i><span>Create House</span>
            </button>
            <button type="button" tabIndex="0" className="dropdown-item" disabled={!activeRecord} onClick={handleEdit}>
                <i className="dropdown-icon fa fa-edit"> </i><span>Edit House</span>
            </button>
        </>)
    }

    return (
        <SettingContainer
            title="School Houses"
            icon="fa fa-home"
            Menu={menu}
            >
      
            {Array.isArray(houses) && <ul className="list-group">
                {houses.map((item) => (
                    
                    <SettingListItem
                        key={item.house_id} 
                        iconName='fa fa-cog'
                        itemName={item.house}
                        onSelect={()=>setActiveRecord(item)}
                        active={item.house_id === activeRecord?.house_id}
                    />
                        
                ))}
            </ul>}
            {houses === '404' && <Notification message="No school houses found" />}
            {!houses && <ActivityLoader />}
       </SettingContainer>

      
    );
};

export default Houses;
